import { createApp } from 'vue'
import App from './App.vue'
import "cesium/Source/Widgets/widgets.css";
const Cesium = require("cesium/Source/Cesium");
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './styles/index.less'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { loadAllPlugins } from './components/index'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { store } from './store'
import { router } from './router'
import './router/timeout'

const app = createApp(App)

// 权限校验 app.config.globalProperties.
const globalAuthorityCheck = (auth: string) => {
  const permissions = localStorage.getItem('permissions');
  const res = permissions?.indexOf(auth)
  let status: boolean
  // 拥有该权限
  if (res !== -1) {
    status = true
  } else {
    status = false
  }
  return status
}


app.directive('checkAuth', {
  // 当被绑定的元素挂载到 DOM 中时……
  mounted(el, binding) {
    const auth = binding.value
    const hideFlag = binding.modifiers.hide
    const status: boolean = globalAuthorityCheck(auth)
    if (status) {
      null
    } else {
      if(hideFlag){
        el.style.display = 'none'
      } else {
        el.style.cursor = 'pointer'
        el.style.pointerEvents = 'none'
        el.style.color = '#ccc'
      }
    }

  }
})

// const getShowRoot = (auth: string) => {
//   const arr:any = [];
//   const permissions :any =  localStorage.getItem('showRootList');
//   const date = JSON.parse(permissions)
//   date.map((item:any)=>{
//     if(item.show===true){
//       arr.push(item.name)
//     }
//   })
//   const res = arr?.indexOf(auth)
//   let status: boolean
//   // 拥有该权限
//   if (res !== -1) {
//     status = true
//   } else {
//     status = false
//   }
//   return status
// }

// app.directive('showRoot', {
//   // 当被绑定的元素挂载到 DOM 中时……
//   mounted(el, binding) {
//     // console.log(binding, 'binding');
//     // console.log(el, 'el');
//     const auth = binding.value
//     const status: boolean = getShowRoot(auth)
//     if (status) {
//       null
//     } else {
//       el.style.display = 'none'
//     }

//   }
// })

// 加载所有插件 
loadAllPlugins(app)

const requireComponent = require.context(
  // 其组件目录的相对路径
  '@/components/package',
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /[A-z]\w+\.(vue|js)$/
)
const res = requireComponent.keys().filter((item: any) => true)
res.forEach((item: any) => {
  const componentConfig = requireComponent(item)
  const name = item
    .split("/") // 将路径以/切割
    .pop() // 删除返回数组最后一个元素
    .replace(/\.\w+/, '') // 正则(切割.vue,\w匹配字符)  +号代表前面的字符必须至少出现一次
  app.component(name, componentConfig.default || componentConfig)
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, { locale: zhCn }).use(store).use(router)

app.provide("Cesium", Cesium).mount('#app')